import { useSelector } from 'react-redux';
import { LocalReportData } from '../../models';
import { selectLocalFileReports } from '../../selectors';

export const useLocalFileReports = (): LocalReportData[] | null => {
  const localFileReports = useSelector(selectLocalFileReports);

  return localFileReports;
};
